import { all, fork } from 'redux-saga/effects';
import loginSaga from './LoginSaga.js';
import signUpSaga from './SignUpSaga.js';
import videoTopicsSaga from './VideoSaga';
import FlashSaga from './FlashSaga';
import QuestionSaga from './QuestionSaga';
import DashboardSaga from './DasboardSaga';
import AchievementSaga from './AchievementSaga';
import SimulatedTestSaga from './SimulatedTestSaga';
import cardPurchaseSaga from './CardPurchaseSaga';

function* dataSaga() {
  yield all([
    fork(loginSaga),
    fork(signUpSaga),
    fork(videoTopicsSaga),
    fork(FlashSaga),
    fork(QuestionSaga),
    fork(DashboardSaga),
    fork(AchievementSaga),
    fork(SimulatedTestSaga),
    fork(cardPurchaseSaga),
  ]);
}

export default dataSaga;
